import hyphenationPatternsEnUs from './../patterns/en-us';
import hyphenationPatternsEs from './../patterns/es';
import hyphenationPatternsFr from './../patterns/fr';
import hyphenationPatternsIt from './../patterns/it';
import hyphenationPatternsPt from './../patterns/pt';
import createHyphenator from './../lib/hyphen';

HTMLElement.prototype.textNodes = function() {
  return [...this.childNodes].filter((node) => {
    return (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "");
  });
}

class Hyphenation {
  constructor(config = {}) {
		const {hyphenSelector, hyphenClass} = config;
		this.hyphenselector = hyphenSelector || '.ns-paragraph, .ns-title-h1, .ns-title-h2, .ns-title-h4, .ns-title-h5';
		this.hyphenClass = hyphenClass || 'hyphenate';

		const hyphenElements = Array.prototype.slice.call(document.querySelectorAll(this.hyphenselector));
		hyphenElements.forEach(el =>{
			el.classList.add('hyphenate');
		});


		switch (document.querySelector('html').getAttribute('lang')) {
			case "en-US":
				this.provideHyphenation(createHyphenator(hyphenationPatternsEnUs), `.${this.hyphenClass}`, {debug:true});
				break;
			case "es-ES":
				this.provideHyphenation(createHyphenator(hyphenationPatternsEs), `.${this.hyphenClass}`);
				break;
			case "fr-FR":
				this.provideHyphenation(createHyphenator(hyphenationPatternsFr), `.${this.hyphenClass}`);
				break;
			case "it-IT":
				this.provideHyphenation(createHyphenator(hyphenationPatternsIt), `.${this.hyphenClass}`);
				break;
			case "pt-PT":
				this.provideHyphenation(createHyphenator(hyphenationPatternsPt), `.${this.hyphenClass}`);
				break;
			default:
				console.log("Hyphenation","undefined language");
		}
	}

	provideHyphenation(hyphenate, sel) {
		const hyphenElements = document.querySelectorAll(sel);
		const hyphenArray = Array.prototype.slice.call(hyphenElements);
		hyphenArray.forEach(el =>{
      el.textNodes().forEach(node => {
        node.textContent = hyphenate(node.textContent);
      });
			// el.innerHTML = hyphenate(el.innerHTML);
		});
	}
}

export default Hyphenation;
